import { UpdateTypeEnum } from "@/model/data/enums/UpdateTypeEnum";
import { VersionObfuscator } from "./updates/VersionObfuscator";

export class InstalledSoftware {
    updateType: UpdateTypeEnum = UpdateTypeEnum.Unknown;
    name: string = null;
    version: string = null;
    lastUpdate: Date = null;

    // constructor(id: number, updateType: UpdateTypeEnum, name: string, version: string, lastUpdate: Date) {
    //   this.id = id;
    //   this.updateType = updateType;
    //   this.name = name;
    //   this.version = version;
    //   this.lastUpdate = lastUpdate;
    // }

    constructor() {}

    get printableVersion(): string {
        return VersionObfuscator.obfuscate(this.version);
    }

    public parse(obj: any) {
        if (obj.UpdateType != null && Object.values(UpdateTypeEnum).includes(obj.UpdateType)) this.updateType = obj.UpdateType;

        if (obj.Name) this.name = obj.Name;

        if (obj.Version) this.version = obj.Version;
        else if (obj.AvailableVersion) this.version = obj.AvailableVersion;

        if (obj.LastUpdate) this.lastUpdate = obj.LastUpdate;
    }
}
